// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fb33e211","743":"84fc1791"}[chunkId] + ".chunk.js";
};